import { NavLink, Route, Routes, Navigate } from 'react-router-dom';
import AccountsPage from './pages/AccountsPage';
import CounterpartiesPage from './pages/CounterpartiesPage';
import JournalEntriesPage from './pages/JournalEntriesPage';
import JournalEntryNewPage from './pages/JournalEntryNewPage';
import DocumentsPage from './pages/DocumentsPage';
import JournalReportPage from './pages/JournalReportPage';
import GeneralLedgerPage from './pages/GeneralLedgerPage';
import TrialBalancePage from './pages/TrialBalancePage';
import IncomeStatementPage from './pages/IncomeStatementPage';
import BalanceSheetPage from './pages/BalanceSheetPage';
import ConsumptionTaxPage from './pages/ConsumptionTaxPage';
import YearEndPage from './pages/YearEndPage';
import EtaxPage from './pages/EtaxPage';

export default function App() {
  return (
    <div className="layout">
      <aside className="sidebar">
        <h1>オンライン帳簿</h1>
        <nav>
          <NavLink to="/journal-entries">仕訳一覧</NavLink>
          <NavLink to="/journal-entries/new">仕訳入力</NavLink>
          <NavLink to="/documents">証憑管理</NavLink>
          <div style={{ margin: '12px 0', borderTop: '1px solid #2a3344' }} />
          <NavLink to="/reports/journal">仕訳帳</NavLink>
          <NavLink to="/reports/general-ledger">総勘定元帳</NavLink>
          <NavLink to="/reports/trial-balance">試算表</NavLink>
          <NavLink to="/reports/income-statement">損益計算書</NavLink>
          <NavLink to="/reports/balance-sheet">貸借対照表</NavLink>
          <NavLink to="/reports/consumption-tax">消費税集計</NavLink>
          <div style={{ margin: '12px 0', borderTop: '1px solid #2a3344' }} />
          <NavLink to="/year-end">年度締め・申告状況</NavLink>
          <NavLink to="/etax">e-Tax 連携</NavLink>
          <div style={{ margin: '12px 0', borderTop: '1px solid #2a3344' }} />
          <NavLink to="/accounts">勘定科目</NavLink>
          <NavLink to="/counterparties">取引先</NavLink>
        </nav>
      </aside>
      <main className="main">
        <Routes>
          <Route path="/" element={<Navigate to="/journal-entries" replace />} />
          <Route path="/journal-entries" element={<JournalEntriesPage />} />
          <Route path="/journal-entries/new" element={<JournalEntryNewPage />} />
          <Route path="/documents" element={<DocumentsPage />} />
          <Route path="/reports/journal" element={<JournalReportPage />} />
          <Route path="/reports/general-ledger" element={<GeneralLedgerPage />} />
          <Route path="/reports/trial-balance" element={<TrialBalancePage />} />
          <Route path="/reports/income-statement" element={<IncomeStatementPage />} />
          <Route path="/reports/balance-sheet" element={<BalanceSheetPage />} />
          <Route path="/reports/consumption-tax" element={<ConsumptionTaxPage />} />
          <Route path="/year-end" element={<YearEndPage />} />
          <Route path="/etax" element={<EtaxPage />} />
          <Route path="/accounts" element={<AccountsPage />} />
          <Route path="/counterparties" element={<CounterpartiesPage />} />
        </Routes>
      </main>
    </div>
  );
}
